import React from 'react';
import { bool, element, node, string } from 'prop-types';

import { Accordion, AccordionTitle, AccordionBody } from '@thd-olt-component-react/core-ui';

import './form-section.scss';

export const FormSection = ({
  children,
  identifier,
  title,
  titleAction,
  accordion,
  display
}) => {

  if (!display) {
    return null;
  }

  if (accordion) {
    return (
      <Accordion
        className="form-accordian-section"
        key={identifier}
        data-testid={identifier}
      >
        <AccordionTitle className="form-accordian-section-title">
          <div
            className="form-accordian-section-title-copy"
          >
            {title}
          </div>
        </AccordionTitle>
        <AccordionBody className="form-accordian-section-content">
          {children}
        </AccordionBody>
      </Accordion>
    );
  }

  return (
    <div className="form-section" id={identifier} data-testid={identifier}>
      <div className="form-section-content">
        {title && (
          <div className="form-section-header">
            <div className="form-section-title">
              {title}
            </div>
            <div className="form-section-title-action">
              {titleAction}
            </div>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

FormSection.propTypes = {
  children: element.isRequired,
  identifier: string.isRequired,
  title: string,
  titleAction: node,
  accordion: bool,
  display: bool.isRequired
};

FormSection.defaultProps = {
  title: '',
  titleAction: <></>,
  accordion: false
};